<template>
  <main>
    <div class="page" id="terms">
      <header class="page-header">
        <h1>もじこ利用規約</h1>
      </header>
      <div class="page-content template">
        <section>
          <p>この利用規約（以下、「本規約」といいます。）は、吉積情報株式会社（以下、「当社」といいます。）が提供する文字起こし専用エディターサービス「もじこ」（以下、「本サービス」といいます。）の利用条件を定めるものです。本サービスをご利用いただくお客様（以下、「サービス利用者」といいます。）には、本規約に従って、本サービスをご利用いただきます。</p>
        </section>
        <section>
          <h2>第1条 適用</h2>
          <ol>
            <li>本規約は、サービス利用者と当社との間における本サービスの利用に適用されるものとし、サービス利用者が本サービスの利用を開始した場合、本規約に同意したものとみなします。</li>
            <li>当社は本サービスに関し、本規約のほか、ご利用にあたってのルール・制限・その他各種の定め（以下、「個別規定」といいます。）を行うことがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。</li>
            <li>本規約の規定が個別規定の内容と矛盾する場合や曖昧さを含む場合には、個別規定の規定が優先されるものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第2条 用語の定義</h2>
          <ul>
            <li>当社：吉積情報株式会社</li>
            <li>本サービス：当社が提供する文字起こし専用エディターサービス「もじこ」</li>
            <li>利用契約：本サービスの利用にあたり当社と契約者がとり交わす契約</li>
            <li>利用申込書：利用契約についての申込書</li>
            <li>契約者：本規約に則り本サービスの利用契約を締結する法人、および担当者</li>
            <li>ユーザー：利用契約に基づく本サービスの利用者</li>
            <li>サービス利用者：契約者ならびにユーザーの総称</li>
            <li>ログインID：本サービスの利用にあたりユーザーが利用するメールアドレス（文字列）とパスワードの組</li>
            <li>利用ドメイン：本サービスの利用を行うドメイン</li>
            <li>対象ファイル：本サービスにより文字起こし処理を行う対象の音声が含まれたファイル</li>
            <li>対象データ：対象ファイルならびに文字起こし処理による出力結果のテキストデータ</li>
            <li>対象システム：インターネット経由で本サービスを提供するWebサーバ、データベース、アプリケーションの総称</li>
            <li>利用料金：本サービスの利用料金</li>
            <li>無料トライアル：本サービスの利用の検討のために当社が定める条件に基づき無償で本サービスの試用を行うこと</li>
            <li>利用時間：本サービスにより自動文字起こし処理を行った利用料金の対象ファイルの時間</li>
            <li>営業日：当社の営業日（祝日法に基づく祝日・年末年始ならびに土曜・日曜を除く日）</li>
            <li>営業時間：営業日の午前10時より午後7時まで</li>
            <li>カスタマーサポート：ユーザーならびに契約者からの本サービス利用に関わるお問い合わせに、当社のスタッフが対応・支援を行うこと</li>
          </ul>
        </section>
        <section>
          <h2>第3条 サービス利用契約の成立</h2>
          <ol>
            <li>本サービスの利用契約は、本規約の規定に則り契約者が当社所定の利用申込書により申し込みを行い、当社がそれを承諾した時に成立します。</li>
            <li>当社は利用申込書に基づき、申し込み内容を承諾する際に本サービスの開通を通知することによって、承諾を行います。</li>
            <li>当社は利用申込書の不備ならびに当社の審査基準に基づき、申し込みを受け付けない場合は、利用申込書記載の契約者宛にその旨連絡を行います。</li>
            <li>当社による利用契約の諾否通知は利用申込書記載のメールアドレスに対して行うものとし、その発信が障害なく行われた時点で到達したものとみなします。</li>
          </ol>
        </section>
        <section>
          <h2>第4条 サービス提供の条件</h2>
          <ol>
            <li>当社が本サービスの提供のために使用するハードウェア、ソフトウェアおよびその他の品目に付帯するあらゆる権利、所有権、知的財産権、権益は、ユーザーに明示的に付与された本規約に従って本サービスを利用する権利を除き、当社に帰属するものとします。</li>
            <li>本サービスを提供する対象システムは原則として24時間365日の稼働を行い、当社の保守による月間目標稼働率は95%とします。</li>
            <li>対象システムに不具合等が発生し本サービスが利用できない場合、当社による不具合の検知・確認から48時間以内を目標として、本サービス提供の初期状態を復旧します。</li>
            <li>カスタマーサポートは当社の営業時間内の対応を原則とします。当社の判断に基づき営業時間を超えて対応を行う場合があります。</li>
            <li>対象システムの不具合等により月間目標稼働率を下回る場合も、当社はいかなる補償（利用料金の一部返金等を含む一切の賠償）も行いません。</li>
          </ol>
        </section>
        <section>
          <h2>第5条 サービス利用者の義務</h2>
          <ol>
            <li>契約者は本サービスを利用するユーザーに本規約ならびに利用契約の規定を遵守させるものとします。サービス利用者による禁止事項への抵触、本規約・利用契約の違反について責任を負うものとします。</li>
            <li>サービス利用者は自己の責任においてログインIDの管理を行い、当該利用ドメインの使用によるサービスの利用にかかる料金を負担するものとします。</li>
            <li>サービス利用者はログインIDの漏洩等の本サービスの不正利用に繋がる可能性を認識した際は、すみやかにカスタマーサポートに連絡を行うものとします。当社は必要に応じて利用ドメインの停止等により対策措置を講じます。</li>
            <li>契約者はサービスの利用申込書記載の内容に変更が生じた際は、遅滞なくカスタマーサポートに連絡を行うものとします。当該通知の不備により生じた負担は契約者が負うものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第6条 ユーザーの禁止事項・保証</h2>
          <ol>
            <li>ユーザーは本サービスの利用にあたり、以下の各号の禁止事項を遵守するものとします。<br>
            ①契約者より許諾された条件以外の用途での本サービスの利用<br>
            ②本サービスに係るプログラム等ならびに対象ソフトウェアに対して複製、改変、リバースエンジニアリング、逆コンパイル、逆アセンブル等の行為<br>
            ③本サービスの利用権の再販、または類する行為</li>
            <li>ユーザーは対象ファイルが、以下の各号のいずれにも該当しないことを保証するものとします。<br>
            ①第三者の知的財産権、プライバシーの権利、またはその他の権利を侵害する内容<br>
            ②本サービスの運営を妨げ、または、妨げるおそれのある内容<br>
            ③その他法令、または公序良俗に反する内容</li>
            <li>ユーザーは、本サービスの利用にあたり、以下の各号の行為を行ってはならないものとします。<br>
            ①当社または第三者の著作権その他の権利を侵害する行為、または侵害するおそれのある行為<br>
            ②当社または第三者の財産、プライバシーもしくは肖像権を侵害する行為、または侵害するおそれのある行為<br>
            ③当社または第三者に不利益もしくは損害を与える行為、またはそのおそれのある行為<br>
            ④犯罪的行為もしくは犯罪的行為に結びつく行為、またはそのおそれのある行為<br>
            ⑤不正にアクセスする行為、クラッキング行為、アタック行為、ウィルス発信行為、その他当社又は第三者の運用する電子計算機端末等に支障を与える行為又はその恐れのある行為<br>
            ⑥事実に反する、またはそのおそれのある情報を提供する行為<br>
            ⑦本サービスの運営を妨げ、もしくはその信用を毀損する行為<br>
            ⑧他人になりすまして各種サービスを利用する行為<br>
            ⑨法令に違反する、または違反するおそれのある行為<br>
            ⑩本サービスのネットワークまたはシステム等に過度な負荷をかける行為<br>
            ⑪その他、前各号に準ずる行為で当社が不適切と判断する行為</li>
          </ol>
        </section>
        <section>
          <h2>第7条 免責事項・責任の制限</h2>
          <ol>
            <li>サービス利用者は以下の各号について、当社が一切の責任を負わないことに同意するものとします。<br>
            ①サービス利用者が行う本サービスの機能を利用した対象データの操作について<br>
            ②対象システムに生じた障害等により本サービスが利用できないためにサービス利用者に生じた逸失利益等の間接的な損害<br>
            ③本サービスの不正利用等の事象を検知したことに基づき、当社が本サービスの利用を停止したことによってサービス利用者に生じた損害<br>
            ④本規約ならびに利用契約に対する違反が認められたことに基づき、当社が本サービスの利用を停止したことによってサービス利用者に生じた損害<br>
            ⑤本サービスの仕様・サービス内容の変更により、サービス利用者に生じた逸失利益等の間接的な損害</li>
            <li>当社の責に帰すべき事由により本サービスの利用に関してサービス利用者に損害が生じた場合は、直近1年分のサービス利用料金を上限とした返金を行うものとし、これを当社が行う唯一の弁済とします。</li>
          </ol>
        </section>
        <section>
          <h2>第8条 サービスの仕様・内容の変更</h2>
          <ol>
            <li>当社は本サービスの機能向上等の目的のため本サービスの仕様・内容を変更することがあります。当該変更についてサービス利用者への影響が予見される場合、必要に応じて契約者に通知を行います。</li>
            <li>当社は本サービスにかかる事業を他社に譲渡する場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びにサービス利用者の登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、サービス利用者は、かかる譲渡につきあらかじめ同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社の分割、その他事業が移転するあらゆる場合を含むものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第9条 サービス利用料金・支払い方法・無料トライアル</h2>
          <ol>
            <li>サービス利用料金は、当月月末（土日祝日の場合は翌営業日に同様の処理を行います）に、前月1日から末日までのご利用料金を集計し、ご請求書をお送りいたします。翌月末までに指定の銀行口座にお振り込みください。</li>
            <li>サービス利用料金は本サービスの機能追加、サービスレベルの向上、物価指数の上昇等の社会情勢の変化に伴い変更となる場合があります。利用料金の変更の際は、ご契約者宛にサービス料金変更のご案内をさせていただき、同意いただいた場合に本サービスのご利用を継続いただく形となります。</li>
            <li>本サービスのご利用を検討される方は、無料トライアルをご利用いただけます。当社担当者よりご案内する申込書に沿ってお申し込みください。</li>
          </ol>
        </section>
        <section>
          <h2>第10条 解約</h2>
          <ol>
            <li>契約者は本サービスの利用を継続しない場合、解約希望日の30日前までに所定の申込書により解約の申し出を行い当社からの承諾の通知を持って、本サービスの利用契約を解約するものとします。</li>
            <li>サービス利用者による本サービスの利用実態が無い場合、当社から契約者へ解約の申し出を行い、契約者からの承諾をもって利用契約を解約するものとします。また、当社からの解約の申し出に対し連絡が不能もしくは相当な期間を経て応答をいただけない場合には解約に同意したものとみなします。</li>
          </ol>
        </section>
        <section>
          <h2>第11条 サービスの中止・利用制限措置</h2>
          <p>当社は、以下のいずれかの事由があると判断した場合、サービス利用者に事前に通知することなく本サービスの全部または一部の提供を停止または中断することが出来るものとします。<br>①本サービスにかかるコンピュータシステムの保守点検または更新を行う場合<br>②地震、落雷、火災、停電、悪疫流行または天災などの不可抗力により、本サービスの提供が困難になった場合<br>③対象システムまたはシステムの基盤となる通信回線等が事故により停止した場合<br>④その他、当社が本サービスの提供が困難と判断した場合<br>⑤サービス利用者が本規約の禁止事項に相当する行為を行ったことが認められた場合</p>
        </section>
        <section>
          <h2>第12条 損害賠償</h2>
          <ol>
            <li>サービス利用者が、本規約ならびに利用契約に違反したこと、又は当社が別途定める禁止事項等を行ったことにより当社が損害を被った場合、利用契約の解約の有無にかかわらず、当社は、当該サービス利用者に対し、被った損害の賠償を請求することができるものとします。</li>
            <li>前項の損害には、他のサービス利用者が被った損害に対し当社が行った賠償も含まれるものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第13条 ユーザー情報等の取り扱い</h2>
          <p>
            サービス利用者は本サービスをご利用いただくユーザーのアクセス状況に関する情報について、個人情報が特定されない形式で当社がサービスの継続・改善に必要な範囲（アクセスログ解析、マーケティングなど）で利用することに同意します。<br>
            アクセス状況に関する情報には、対象ファイル、対象データは含まれません。
          </p>
        </section>
        <section>
          <h2>第14条 データの取り扱い</h2>
          <p>
            対象ファイル、対象データについては、当社が利用することはありません。<br>
            対象ファイルについては、本サービスの「使用」終了後に都度、復元不能な状態で削除いたします。<br>
            対象データについては、サービス利用者本人の管理するクラウドストレージサービス上に保存され、ログインIDを保有するサービス利用者のみがアクセスが可能となっています。<br>
          </p>
        </section>
        <section>
          <h2>第15条 秘密保持</h2>
          <p>サービス利用者は本サービス内で取得した本サービスの仕様・機能等に関する情報は非公知の情報とし、秘密として管理するものとします。但し、当該情報について当社からの書面による事前の同意がある場合はこの限りではありません。</p>
        </section>
        <section>
          <h2>第16条 反社会的勢力の排除</h2>
          <ol>
            <li>サービス利用者は、暴力団、暴力団員、暴力団構成員もしくはそれらの関係者、総会屋、その他反社会的勢力（以下これらを「反社会的勢力」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを表明保証します。<br>（１）反社会的勢力が経営を支配していると認められる関係を有すること。<br>（２）反社会的勢力が経営に実質的に関与していると認められる関係を有すること。<br>（３）自己もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること。<br>（４）暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること。<br>（５）役員または経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること。</li>
            <li>当社は、契約者が前項の表明保証に反して、前項各号のいずれか一にでも該当することが判明したときは、何ら催告をせず、利用契約を解除することができるものとします。</li>
            <li>本条に基づく利用契約の解除により契約者に損害が生じた場合であっても、当社は一切の責任を負わず、契約者が当社に対して負担する一切の債務についてその期限の利益を喪失するものとします。</li>
          </ol>
        </section>
        <section>
          <h2>第17条 権利義務と譲渡の禁止</h2>
          <p>サービス利用者は当社の書面による事前の承諾なく、本規約および利用契約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。</p>
        </section>
        <section>
          <h2>第18条 規約の変更</h2>
          <p>当社は、必要と判断した場合には、本規約を変更することができるものとします。本規約は本サービスの画面からサービス利用者が参照可能な状態を維持し、本サービスの利用条件は常に変更後の本規約に基づくものとします。</p>
        </section>
        <section>
          <h2>第19条 準拠法・合意管轄裁判所</h2>
          <p>本規約の解釈にあたっては、日本法を準拠法とします。<br>本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。</p>
        </section>
        <section class="over">
          <p>以上</p>
          <p><a href="/terms-20200923/" rel="noopener" target="_blank" class="textdeco">2020年9月23日制定</a><br>
          2021年8月17日改定</p>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  },
  computed: {

  },
  apollo: {

  }
}
</script>

<style lang="stylus" scoped>


</style>
